module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAALCAYAAABcUvyWAAAAAXNSR0IArs4c6QAAAG9JREFUGBljOHr09s5Tp+4bMKABJkZGjqQ/f37PQJdkBCk8duyxNAPD97UsLKwZZmaKF0BiYAlkSaBQppWV6nm4BLokigRE8p7Z//9/F6NIwOwCGQeXQBaE24EuCDKSESaI7FSQBNP//z+moQuCJACKnz805PdawQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tu4.png
// module id = LVg9
// module chunks = 3